window.efScripts.variantFilters = [];
window.efScripts.onVariantsFilter = [];

// Async filtering script
$(document).ready(function () {
    preloadQueryParams();
    window.efScripts.applyVariantFilters = applyVariantFilters;
    window.efScripts.fetchVariants = fetchVariants;
    window.efScripts.fetchNextVariants = fetchNextVariants;
    window.efScripts.onLoadMoreClickHandler = onLoadMoreClickHandler;
    fetchVariants();
});

function applyVariantFilters() {
    // Call all bind functions
    for (i = 0; i < window.efScripts.onVariantsFilter.length; i++) {
        window.efScripts.onVariantsFilter[i]();
    }
    fetchVariants();
}

function onLoadMoreClickHandler(e) {
    const next_page = $(e).data('page');

    fetchNextVariants(next_page);
}

function fetchNextVariants(page = 1) {
    const filtersUrl = constructUrl(window.efScripts.variantFilters);

    jQuery.ajax({
        type: 'POST',
        url: efScripts.ajaxUrl,
        data: {
            'action': 'eduframe_get_variants',
            ...window.efScripts.variantFilters,
            page: page
        },
        timeout: 5000,
        beforeSend: function () {
            jQuery(window).unbind('scroll');
            jQuery('#ef-load-more-container').html(`<div style="text-align:center;"><img src="${efScripts.loadingImage}" style="width:70px;" /></div>`);
        },
        success: function (response) {
            jQuery('#ef-load-more-container').remove();
            jQuery('#filtered_variants').append(response);

            window.history.pushState({}, null, filtersUrl);
        },
        error: function (xhr, textStatus, errorThrown) {
            jQuery('#filtered_variants').append(xhr.responseText);
        }
    });
}

function fetchVariants() {
    const filtersUrl = constructUrl(window.efScripts.variantFilters);

    jQuery.ajax({
        type: 'POST',
        url: efScripts.ajaxUrl,
        data: {
            'action': 'eduframe_get_variants',
            ...window.efScripts.variantFilters,
        },
        timeout: 5000,
        beforeSend: function () {
            jQuery('#filtered_variants').html(`<div style="text-align:center;"><img src="${efScripts.loadingImage}" style="width:70px;" /></div>`);
        },
        success: function (response) {
            jQuery('#filtered_variants').html(response);

            window.history.pushState({}, null, filtersUrl);
        },
        error: function (xhr, textStatus, errorThrown) {
            jQuery('#filtered_variants').html(xhr.responseText);
        }
    });
}

function constructUrl(variantFilters) {
    const filtersUrl = new URL(location.href);
    filtersUrl.search = new URLSearchParams(); // Clear search params since we re add the selected filters
    for (const variantFilter in variantFilters) {
        if (variantFilters.hasOwnProperty(variantFilter)) {
            if (variantFilters[variantFilter].length > 0) {
                filtersUrl.searchParams.append(encodeURIComponent(variantFilter), variantFilters[variantFilter]);
            }
        }
    }
    return filtersUrl;
}

function preloadQueryParams() {
    const filtersUrl = new URL(location.href);
    ['teachers', 'labels', 'courseVariants', 'locations', 'search'].forEach(function (param) {
        const query = filtersUrl.searchParams.get(param);
        window.efScripts.variantFilters[param] = query ? query.split(',') : [];
    });
}